import { render } from "./BackTestGraph.vue?vue&type=template&id=6e90a1fb&ts=true"
import script from "./BackTestGraph.vue?vue&type=script&lang=ts"
export * from "./BackTestGraph.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__